import { createI18n } from 'vue-i18n'

/** @ts-ignore-next-line */
import en from '../../lang/en.json'
/** @ts-ignore-next-line */
import { messageCompiler } from './compiler.ts'

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  fallbackLocale: 'en',
  messageCompiler: messageCompiler,
  // Pre-load English by default to prevent flickers
  messages: {
    en,
  },
})

export async function setLocale(locale: string) {
  const mappedLocale = LOCALE_MAPPING[locale] ?? 'en-US'
  const messages = await import(`../../lang/${mappedLocale}.json`)

  /** @ts-ignore-next-line */
  i18n.global.locale.value = locale
  i18n.global.setLocaleMessage(locale, messages.default)
}

export const getActiveLanguage = () => i18n.global.locale.value

export const t = i18n.global.t
export const trans = t

const LOCALE_MAPPING: Record<string, string> = {
  'bg': 'bg-BG',
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'el': 'el-GR',
  'en': 'en-US',
  'es': 'es-ES',
  'es-MX': 'es-419',
  'et': 'et-EE',
  'fi': 'fi-FI',
  'fil': 'fil-PH',
  'fr': 'fr-FR',
  'hr': 'hr-HR',
  'hu': 'hu-HU',
  'id': 'id-ID',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'lv': 'lv-LV',
  'lt': 'lt-LT',
  'ms': 'ms-MY',
  'mt': 'mt-MT',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'no': 'nb-NO',
  'nn': 'nb-NO',
  'pl': 'pl-PL',
  'pt': 'pt-PT',
  'sk': 'sk-SK',
  'sl': 'sl-SI',
  'sv': 'sv-SE',
  'th': 'th-TH',
  'tr': 'tr-TR',
  'vi': 'vi-VN',
  'zh': 'zh-Hans',
  'zh-CN': 'zh-Hans',
  'zh-HK': 'zh-Hant-HK',
  'zh-TW': 'zh-Hant-TW',
}
